const getUpdatedOrPrependedList = (list, data) => {
  if (!list) { return []; }
  const index = list.findIndex(({ id }) => (id === data.id));
  if (index < 0) { return [data, ...list]; }
  const newList = [...list];
  newList[index] = data;
  return newList;
};

export { getUpdatedOrPrependedList };
